/**
 * The service a requirement is for, as a tile's name.
 *
 * Read from the requirement's own words, so the tiles are the services a
 * client actually takes — Dr Akshay gets Reels, LinkedIn and Articles, not a
 * fixed Reels / Posts / Stories row with nothing in two of them. Across all
 * clients the same service is one tile: "4 Reels" and "Reels" are both Reels,
 * and a carousel is an Instagram post.
 */
export function serviceOf(r: { metric: string; unit: string }): string {
  const t = `${r.metric} ${r.unit}`.toLowerCase()
  if (/linkedin/.test(t)) return 'LinkedIn'
  if (/youtube|\bshorts?\b/.test(t)) return 'YouTube Shorts'
  if (/pinterest|\bpins?\b/.test(t)) return 'Pinterest'
  if (/\bgbp\b|\bgmb\b|google business/.test(t)) return 'Google Business'
  if (/substack/.test(t)) return 'Substack'
  if (/business brief/.test(t)) return 'Business Brief Reels'
  if (/happenswork/.test(t)) return 'Happenswork Reels'
  if (/\breels?\b/.test(t)) return 'Reels'
  if (/carousel|instagram/.test(t)) return 'Instagram Posts'
  if (/article|blog/.test(t)) return 'Articles'
  if (/\bposts?\b/.test(t)) return 'Posts'
  // Anything else by its own name, without the count in front of it.
  return r.metric.replace(/^\s*\d+\s*/, '').trim() || r.metric
}
